import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConfigService } from '../config/config.service';
import { StringVariableService } from '../string-variable/string-variable.service';
import { Dictionary } from '@cudirect/shared-ui-library';

@Injectable({
  providedIn: 'root'
})
export class WorkflowDictionaryService {
  private readonly subscriptions: Subscription[] = [];

  constructor(private readonly configService: ConfigService, private readonly stringVariableService: StringVariableService) {}

  /**
   * Read a key, guaranteed to return a string (i.e. empty string for invalid and missing keys)
   *
   * @param keys reference hierarchized keys in one or more literals (i.e: 'a/b/c' or 'a', 'b', 'c' as arguments)
   * @returns dictionary entry
   */
  public read(...keys: string[]): string {
    return (this.configService.read('dictionary/' + keys.join('/'), true) as string) || '';
  }

  /**
   * Read a key, guaranteed to return a string (i.e. empty string for invalid and missing keys), will process through StringVariableService
   * @param path 'a/b/c'
   * @param iterationId loop id
   * @param pageIterationIdId id of subpage
   * @returns dictionary entry
   */
  public readParsed(path: string, iterationId?: number, pageIterationIdId?: number): string {
    return this.stringVariableService.parse(this.read(path), iterationId, pageIterationIdId) as string;
  }

  /**
   * Reads a segment of current dictionary
   *
   * @param keys reference hierarchized keys in one or more literals (i.e: 'a/b/c' or 'a', 'b', 'c' as arguments)
   * @return dictionary entry OR undefined (for invalid key) OR object (dictionary subtree)
   */
  public readSegment(...keys: string[]): Dictionary | string | [] {
    if (!keys.length) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return <Dictionary | string | []>this.configService.read('dictionary/' + keys.join('/'));
  }
}
